define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ServiceTypeModel = /** @class */ (function () {
        function ServiceTypeModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.ProviderId = ko.observable();
            this.ProviderName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ServiceTypeModel.Mapping, self);
            }
        }
        ServiceTypeModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ServiceTypeModel(options.data);
            }
        };
        return ServiceTypeModel;
    }());
    return ServiceTypeModel;
});
//# sourceMappingURL=ServiceTypeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ServiceTypeModel.js
// module id = 223
// module chunks = 2